import React, { useEffect } from "react"; 
import { Link } from 'react-router-dom';
import axios from 'axios'; 
// react plugin for creating charts
// @mui/material
import { useTheme } from "@mui/material/styles";
import { CardContent } from "@mui/material";
import AccessTime from "@mui/icons-material/AccessTime";
// core components
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody";
import CardFooter from "../../components/Card/CardFooter.jsx";
import { baseUrl } from '../../components/shared/baseUrl';
import { mongoUrl } from '../../components/shared/mongoUrl';
import styles from "../../components/assets/jss/material-dashboard-react/views/dashboardStyle.js";




const checkDiff = (time) =>{
  var prev = new Date(time);
  console.log(prev)

  var current = new Date();
  var seconds = Math.floor((current - prev)/1000);
  var minutes = Math.floor(seconds/60);
  var hours = Math.floor(minutes/60);
  var days = Math.floor(hours/24);
  hours = hours-(days*24);
  minutes = minutes-(days*24*60)-(hours*60);
  seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);
  

  if(minutes<60 && days==0 && hours==0){
  return(
    <p> {minutes} minutes ago </p>
  );
  }
  else if(hours>0 && days == 0){
    
    return(
      <p>{hours} hours {minutes} minutes ago </p>
    );
  }
  else if(days>0){
    return(
      <p>  {days} days ago </p>
    );

  }
}

function RenderClassItem({ clas }){
  

  return(
        <Link to={`/admin/dashboard/viewclass/${clas._id}`}>
          <Card>
            <CardContent>
            {clas.image.substring(0,6)!=='assets'?
            <img alt={`${clas.title}`} className="card-img-top" src={mongoUrl+clas.image} />
            :<img alt={`${clas.title}`} className="card-img-top" src={baseUrl+clas.image} />}
            </CardContent>
            <CardBody>
              <h4 sx={styles.cardTitle}>{clas.title}</h4>
              <p sx={styles.cardCategory}>
                {/* <span className={classes.successText}>
                  <ArrowUpward className={classes.upArrowCardCategory} /> 55%
                </span>{" "} */}
                std: {clas.std}  | session: inactive | Created: {checkDiff(clas.Created)} 
                
              </p>
            </CardBody>
            {console.log(clas.lastViewed)}
            <CardFooter chart>
              <div sx={styles.stats}>
                <AccessTime /> viewed:  {checkDiff(clas.lastViewed)} 
              </div>
            </CardFooter>
          </Card>
          </Link>
        );

}

export default function Dashboard(props) {
  const theme = useTheme()
  //const classes = styles(theme);
  const [classe, setclasse] = React.useState([]);
  const [loading, setloading] = React.useState(true);
   
  useEffect(() => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const loadData=()=>{
    
    axios.get(`${baseUrl}class`, { cancelToken: source.token })
    .then((response) => {
      const dat = Array.from(response.data)
    setclasse(dat)
    setloading(false)
    //props.mod=response.data;

    })
    .catch((error)=>{
    console.log(error);
    });
  };
    loadData();

    return() => {source.cancel();
    };
}, []);

//console.log(classe)

  const menu=classe.map((clas) => {
    return (
          <GridItem xs={12} sm={9} md={3} key={clas._id}>
                <RenderClassItem clas={clas} />
          </GridItem>
    );
})


  return (
    <div>
      {/* <Link to="/admin/dashboard/createclass">

        <Tooltip
          arrow
          title="Create your new class to start inquiry session"
          placement="bottom">
          <Fab
          variant="extended"
          color="default"
          size="medium"
          className="ml-3"
          >
          <AddIcon />
                Create class
          </Fab>
        </Tooltip>
      </Link> */}
        <div className="container">
          <div className="px-0 col-lg-8 col-md-10 col-sm-12 mx-auto text-center">
              <h1 className="display-3 mb-4 font-weight-bold">
                  My Classes 
              </h1>
              <p className="font-size-lg text-black-100">
                      Classes with active inquiry session
              </p>
          </div>
        </div>
        {loading===false? 
        <GridContainer>
          {menu} 
        </GridContainer>: null}

      <div className="container">
          <div className="px-0 col-lg-8 col-md-10 col-sm-12 mx-auto text-center">
              <p className="font-size-lg text-black-100">
                      Classes with no active inquiry session
              </p>
          </div>
        </div>
    </div>
  );
}
